<template>
  <div class="addMissionHour">
    <box :title="$t('missionDetails')">
      <v-row class="pa-2">
        <v-col cols="6"
          >{{ $t("PageNo") }}:<span class="text-value">{{
            details.PageNo
          }}</span></v-col
        >

        <v-col cols="6"
          >{{ $t("requestType") }}:<span class="text-value">{{
            details.Name
          }}</span></v-col
        >

        <v-col cols="6"
          >{{ $t("cityName") }}:<span class="text-value">{{
            details.CityName
          }}</span></v-col
        >
        <v-col cols="6"
          >{{ $t("missionLocation") }}:<span class="text-value">{{
            details.Location
          }}</span></v-col
        >
        <v-col cols="6"
          >{{ $t("BeginDate") }}:<span class="text-value">{{
            details.BeginDate
          }}</span></v-col
        >
        <v-col cols="6"
          >{{ $t("EndDate") }}:<span class="text-value">{{
            details.EndDate
          }}</span></v-col
        >
      </v-row>

      <div class="mx-2">
        <v-icon>mdi-info</v-icon>
        <span class="mx-2"
          >برای وارد کردن ساعت لطفا ساعت مورد نظر را انتخاب کنید :</span
        >
      </div>

      <v-card class="ma-2">
        <v-data-table
          :items="missionHourList"
          :headers="missionHourHeader"
          disable-pagination
          disable-sort
          hide-default-footer
          dense
        >
          <template v-slot:item.BeginTime="props">
            <div class="pa-1">
              <dialog-time-picker
                :label="$t('BeginTime') + ':'"
                :initTime="ConvertToEnglishDigits(props.item.beginTime)"
                @dateResult="bTime($event, props)"
              />
            </div>
          </template>

          <template v-slot:item.EndTime="props">
            <dialog-time-picker
              :label="$t('EndTime') + ':'"
              :initTime="ConvertToEnglishDigits(props.item.EndTime)"
              @dateResult="eTime($event, props)"
            />
          </template>
        </v-data-table>
      </v-card>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          @click="btnSaveClick"
          :loading="loading"
          :disabled="loading"
          >{{ $t("save") }}</v-btn
        >
      </v-card-actions>
    </box>
  </div>
</template>

<script>
import ResultType from "../../model/ResultType";
import TextUtils from "../../utils/TextUtils";
import i18n from "../../i18n";
import DialogTimePicker from "../../components/widget/DialogTimePicker.vue";
import EosToastType from "../../model/EosToastType";

export default {
  components: { DialogTimePicker },
  data() {
    return {
      perno: "",
      beginDate: "",
      endDate: "",
      missionType: "",
      year: "",
      pageNo: "",
      details: {},
      loading: false,
      missionHourList: [],
      missionHourHeader: [
        {
          text: i18n.t("date"),
          value: "DayDate",
        },
        {
          text: i18n.t("DayName"),
          value: "DayName",
        },
        {
          text: i18n.t("BeginTime"),
          value: "BeginTime",
        },
        {
          text: i18n.t("EndTime"),
          value: "EndTime",
        },
      ],
    };
  },
  mounted() {
    this.pageLoad();
  },
  methods: {
    bTime(date, props) {
      var bb = this.missionHourList

      console.log(bb)
      console.log(date)
      props.item.BeginTime=date ;
    },
    eTime(date, props) {
      props.item.EndTime = date;
    },
    rowClicked(item) {
      console.log(item);
    },
    async pageLoad() {
      // //debugger
    
      this.perno = this.$route.query.pid;
      this.beginDate = this.$route.query.bd;
      this.endDate = this.$route.query.ed;
      this.missionType = this.$route.query.t;
      this.year = this.$route.query.y;

      this.$store
        .dispatch("GetMissionPageNo", {
          params: {
            perno: this.perno,
            beginDate: this.beginDate,
            endDate: this.endDate,
            missionType: this.missionType,
            year: this.year,
          },
        })
        .then((result) => {
         
          console.log(result);
          if (result.type == ResultType.success) {
            this.pageNo = result.data.Status;
            this.GetMissionDetailForPerson();
          }
        });
    },
    GetMissionDetailForPerson() {
      const params = new URLSearchParams();
      params.append("pageNo", TextUtils.convertToEnglishDigits(this.pageNo));
      params.append("dbkind", "1");
      params.append("year", this.year);
      params.append("perno", this.perno);
      // //debugger
      this.$store
        .dispatch("GetMissionDetailForPerson", { params })
        .then((result) => {
          
          if (result.type == "success") {
            if (result.data.length > 0) {
              this.details = result.data[0];
              this.GetMissionHourForMission(this.details);
            }
          }
        });
    },
    GetMissionHourForMission(item) {
      //console.log(item);
// //debugger
      this.missionHourList = [];
      if (item.IsDaily) {
        this.rdGridTimesVisible = true;
        var GetMissionHourForMissionParams = {
          pageNo: TextUtils.convertToEnglishDigits(this.pageNo),
          year: this.year,
          dbKind:1
        };
        console.log('ndn:'+GetMissionHourForMissionParams)
        // //debugger
        this.$store
          .dispatch("GetMissionHourForMission", {
            GetMissionHourForMissionParams,
          })
          .then((result) => {
            //console.log(result);
            // //debugger
            if (result.type == ResultType.success) {
              this.missionHourList = result.data;
            }
          });
      }
    },
    btnSaveClick() {
      this.loading = true;
      var promises = [];
      this.missionHourList.forEach((element) => {
        //debugger;
        if (element.BeginTime != "&nbsp;") {
          promises.push(this.AddMissionHour(element));
        }
      });
      Promise.all(promises).then((results) => {
        //console.log(results);
        this.loading = false;
        var failed = results.find((result) => result == false);
        if (!failed) {
          this.$router.push({ name: "request-mission-archive" });
        }
      });
    },
    AddMissionHour(element) {
      // //debugger
      var localPerno = this.perno
      var currentYear=this.year
      var completeBeginDate=currentYear+'/'+element.BeginDate
      var completeBEndDate=currentYear+'/'+element.BeginDate
      
      return this.$store
        .dispatch("AddMissionHour", {
          data: {
            BeginDate: completeBeginDate,
            EndDate: completeBEndDate,
            BeginTime: element.BeginTime,
            EndTime: element.EndTime,
            Perno: localPerno,
            PageNo: element.PageNo,
            Description: this.details.UserDescription,
            MissionType: this.details.Type,
            CityCode: this.details.City,
            Place: this.details.Location,
          },
        })
        .then((result) => {
          //console.log(result);
          if (result.type == ResultType.success) {
            if (result.data[0].Status == "1") {
              this.$EosToast.show({
                type: EosToastType.success,
                // msg: `ثبت ساعت برای تاریخ ${element.DayDate} با موفقیت انجام شد`,
                msg: `ثبت ساعت برای تاریخ مورد نظر با موفقیت انجام شد`,
              });
              return true;
            } else {
              this.$EosToast.show({
                type: EosToastType.error,
                // msg: `ثبت ساعت برای تاریخ ${element.DayDate} با خطا مواجه شد`,
                msg: `ثبت ساعت برای تاریخ مورد نظر با خطا مواجه شد`,
              });
              return false;
            }
          }
          return false;
        });
    },
  },
};
</script>

<style>
</style>